export const enum ChecklistType {
    OTHER = 1,
    TIMESHEETS_UPLOADED = 2,
    FACILITY_SIGNED_TIMESHEETS = 3,
    PROVIDERS_SIGNED_TIMESHEETS = 4,
    FACILITY_CONTACT_RECEIVE_INVOICE_EMAIL = 5,
    SHIFT_RECEIPTS_RECEIVED = 6,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/ChecklistType.ts